(function (root, factory) {
  var data = factory();
  if (typeof module === 'object' && module.exports) module.exports = data;
  if (root) root.SiokiuuGeneratorSizeData = data;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  return {
  "catalogs": {
    "home": [
      {
        "scenario": "home",
        "id": "home-refrigerator-standard",
        "category": "Refrigeration",
        "name": "Refrigerator — Standard",
        "runningWatts": 400,
        "startingWatts": 1200,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": false,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-refrigerator-large",
        "category": "Refrigeration",
        "name": "Refrigerator — Large / Older",
        "runningWatts": 700,
        "startingWatts": 2200,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": false,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-freezer",
        "category": "Refrigeration",
        "name": "Chest or Upright Freezer",
        "runningWatts": 500,
        "startingWatts": 1000,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": false,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-led-lights",
        "category": "Lighting & Connectivity",
        "name": "LED Lights — About 6 Bulbs",
        "runningWatts": 60,
        "startingWatts": 60,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-router",
        "category": "Lighting & Connectivity",
        "name": "Modem & Wi-Fi Router",
        "runningWatts": 20,
        "startingWatts": 20,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": false,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-tv",
        "category": "Medical & Electronics",
        "name": "LED Television",
        "runningWatts": 200,
        "startingWatts": 200,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-laptop",
        "category": "Medical & Electronics",
        "name": "Laptop Computer",
        "runningWatts": 100,
        "startingWatts": 100,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-desktop",
        "category": "Medical & Electronics",
        "name": "Desktop Computer & Monitor",
        "runningWatts": 700,
        "startingWatts": 700,
        "loadType": "electronic",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-device-charging",
        "category": "Medical & Electronics",
        "name": "Phones & Tablet Charging",
        "runningWatts": 40,
        "startingWatts": 40,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-cpap-basic",
        "category": "Medical & Electronics",
        "name": "CPAP — Without Heated Humidifier",
        "runningWatts": 60,
        "startingWatts": 60,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": false,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-cpap-heated",
        "category": "Medical & Electronics",
        "name": "CPAP — With Heated Humidifier",
        "runningWatts": 120,
        "startingWatts": 120,
        "loadType": "electronic",
        "voltage": 120,
        "popular": false,
        "userControlled": false,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-security",
        "category": "Medical & Electronics",
        "name": "Home Security System",
        "runningWatts": 40,
        "startingWatts": 40,
        "loadType": "electronic",
        "voltage": 120,
        "popular": false,
        "userControlled": false,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-ceiling-fan",
        "category": "Heating & Cooling",
        "name": "Ceiling Fan",
        "runningWatts": 75,
        "startingWatts": 75,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-window-fan",
        "category": "Heating & Cooling",
        "name": "Window or Box Fan",
        "runningWatts": 200,
        "startingWatts": 200,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-furnace-blower",
        "category": "Heating & Cooling",
        "name": "Gas Furnace Blower — Up to 1/2 HP",
        "runningWatts": 800,
        "startingWatts": 1600,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": false,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": true,
        "notes": "Confirm voltage and wattage before use."
      },
      {
        "scenario": "home",
        "id": "home-window-ac-5000",
        "category": "Heating & Cooling",
        "name": "Window A/C — 5,000 BTU",
        "runningWatts": 600,
        "startingWatts": 1200,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-window-ac-10000",
        "category": "Heating & Cooling",
        "name": "Window A/C — 10,000 BTU",
        "runningWatts": 1200,
        "startingWatts": 2400,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-garage-door",
        "category": "Household",
        "name": "Garage Door Opener",
        "runningWatts": 720,
        "startingWatts": 1420,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-microwave",
        "category": "Kitchen",
        "name": "Microwave Oven",
        "runningWatts": 1200,
        "startingWatts": 1200,
        "loadType": "steady",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-coffee-maker",
        "category": "Kitchen",
        "name": "Coffee Maker",
        "runningWatts": 1200,
        "startingWatts": 1200,
        "loadType": "steady",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-kettle",
        "category": "Kitchen",
        "name": "Electric Kettle",
        "runningWatts": 1500,
        "startingWatts": 1500,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-air-fryer",
        "category": "Kitchen",
        "name": "Air Fryer / Toaster Oven",
        "runningWatts": 1500,
        "startingWatts": 1500,
        "loadType": "steady",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-space-heater",
        "category": "Heating & Cooling",
        "name": "Portable Space Heater",
        "runningWatts": 1500,
        "startingWatts": 1500,
        "loadType": "steady",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-washer",
        "category": "Household",
        "name": "Washing Machine",
        "runningWatts": 1000,
        "startingWatts": 2300,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-dishwasher",
        "category": "Household",
        "name": "Dishwasher",
        "runningWatts": 1800,
        "startingWatts": 1800,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "home-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-electric-blanket",
        "category": "Household",
        "name": "Electric Blanket",
        "runningWatts": 200,
        "startingWatts": 200,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "home",
        "id": "home-central-ac",
        "category": "High-Power / Unsupported",
        "name": "Central Air Conditioner",
        "runningWatts": 3500,
        "startingWatts": 6000,
        "loadType": "motor",
        "voltage": 240,
        "popular": false,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": false,
        "unsupportedReason": "Most central air conditioners require 240V and exceed the current SIOKIUU lineup."
      },
      {
        "scenario": "home",
        "id": "home-electric-dryer",
        "category": "High-Power / Unsupported",
        "name": "Full-Size Electric Clothes Dryer",
        "runningWatts": 6000,
        "startingWatts": 6000,
        "loadType": "steady",
        "voltage": 240,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": false,
        "unsupportedReason": "This appliance normally requires 240V and exceeds the current SIOKIUU lineup."
      },
      {
        "scenario": "home",
        "id": "home-water-heater",
        "category": "High-Power / Unsupported",
        "name": "Electric Water Heater",
        "runningWatts": 4500,
        "startingWatts": 4500,
        "loadType": "steady",
        "voltage": 240,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": false,
        "unsupportedReason": "This appliance normally requires 240V and is not supported by the current SIOKIUU lineup."
      }
    ],
    "rv": [
      {
        "scenario": "rv",
        "id": "rv-ac-11000",
        "category": "Air Conditioning",
        "name": "RV Air Conditioner — 11,000 BTU",
        "runningWatts": 1010,
        "startingWatts": 1600,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-ac-13500",
        "category": "Air Conditioning",
        "name": "RV Air Conditioner — 13,500 BTU",
        "runningWatts": 1800,
        "startingWatts": 2800,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-ac-15000",
        "category": "Air Conditioning",
        "name": "RV Air Conditioner — 15,000 BTU",
        "runningWatts": 2000,
        "startingWatts": 3300,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true,
        "notes": "Actual startup demand varies significantly. Check the A/C label and soft-start configuration."
      },
      {
        "scenario": "rv",
        "id": "rv-refrigerator",
        "category": "RV Essentials",
        "name": "RV Refrigerator",
        "runningWatts": 180,
        "startingWatts": 600,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": false,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-mini-fridge",
        "category": "RV Essentials",
        "name": "Mini Fridge / Electric Cooler",
        "runningWatts": 100,
        "startingWatts": 600,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": false,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-converter",
        "category": "RV Essentials",
        "name": "RV Converter / Battery Charger",
        "runningWatts": 300,
        "startingWatts": 300,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": false,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": true,
        "notes": "Converter input varies by model and battery charging state."
      },
      {
        "scenario": "rv",
        "id": "rv-led-lights",
        "category": "RV Essentials",
        "name": "RV LED Lights",
        "runningWatts": 60,
        "startingWatts": 60,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-tv",
        "category": "Electronics",
        "name": "RV Television",
        "runningWatts": 120,
        "startingWatts": 120,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-laptop",
        "category": "Electronics",
        "name": "Laptop Computer",
        "runningWatts": 250,
        "startingWatts": 250,
        "loadType": "electronic",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-device-charging",
        "category": "Electronics",
        "name": "Phones & Device Charging",
        "runningWatts": 50,
        "startingWatts": 50,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-cpap",
        "category": "Comfort & Personal Care",
        "name": "CPAP with Heated Humidifier",
        "runningWatts": 120,
        "startingWatts": 120,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": false,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-satellite",
        "category": "Electronics",
        "name": "Satellite Receiver",
        "runningWatts": 250,
        "startingWatts": 250,
        "loadType": "electronic",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-game-console",
        "category": "Electronics",
        "name": "Gaming Console",
        "runningWatts": 180,
        "startingWatts": 180,
        "loadType": "electronic",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-microwave",
        "category": "Kitchen",
        "name": "RV Microwave",
        "runningWatts": 1000,
        "startingWatts": 1000,
        "loadType": "steady",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-coffee-maker",
        "category": "Kitchen",
        "name": "Coffee Maker",
        "runningWatts": 1200,
        "startingWatts": 1200,
        "loadType": "steady",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-toaster",
        "category": "Kitchen",
        "name": "Toaster",
        "runningWatts": 1400,
        "startingWatts": 1400,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-kettle",
        "category": "Kitchen",
        "name": "Electric Kettle",
        "runningWatts": 1500,
        "startingWatts": 1500,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-electric-grill",
        "category": "Kitchen",
        "name": "Tabletop Electric Grill",
        "runningWatts": 1650,
        "startingWatts": 1650,
        "loadType": "steady",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-induction-cooktop",
        "category": "Kitchen",
        "name": "Portable Induction Cooktop",
        "runningWatts": 1800,
        "startingWatts": 1800,
        "loadType": "electronic",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-water-heater",
        "category": "RV Essentials",
        "name": "RV Electric Water Heater",
        "runningWatts": 1500,
        "startingWatts": 1500,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-smoker",
        "category": "Kitchen",
        "name": "Electric Smoker",
        "runningWatts": 1200,
        "startingWatts": 1200,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-slow-cooker",
        "category": "Kitchen",
        "name": "Slow Cooker",
        "runningWatts": 270,
        "startingWatts": 270,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-hair-dryer",
        "category": "Comfort & Personal Care",
        "name": "Hair Dryer",
        "runningWatts": 1800,
        "startingWatts": 1900,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-blender",
        "category": "Kitchen",
        "name": "Blender",
        "runningWatts": 400,
        "startingWatts": 850,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-portable-fan",
        "category": "Comfort & Personal Care",
        "name": "Portable Fan",
        "runningWatts": 40,
        "startingWatts": 120,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-iron",
        "category": "Comfort & Personal Care",
        "name": "Clothes Iron",
        "runningWatts": 1800,
        "startingWatts": 1800,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "rv",
        "id": "rv-washer",
        "category": "RV Essentials",
        "name": "Compact RV Washing Machine",
        "runningWatts": 1500,
        "startingWatts": 1500,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "rv-controlled-high-draw",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      }
    ],
    "jobsite": [
      {
        "scenario": "jobsite",
        "id": "job-led-lights",
        "category": "Lighting & Charging",
        "name": "LED Work Lights",
        "runningWatts": 100,
        "startingWatts": 100,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-halogen-light",
        "category": "Lighting & Charging",
        "name": "Halogen Work Light",
        "runningWatts": 500,
        "startingWatts": 500,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-battery-chargers",
        "category": "Lighting & Charging",
        "name": "Standard Tool Battery Chargers",
        "runningWatts": 300,
        "startingWatts": 300,
        "loadType": "electronic",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-drill-38",
        "category": "Drilling",
        "name": "Corded Drill — 3/8 in.",
        "runningWatts": 440,
        "startingWatts": 600,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-drill-12",
        "category": "Drilling",
        "name": "Corded Drill — 1/2 in.",
        "runningWatts": 600,
        "startingWatts": 900,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-circular-saw",
        "category": "Cutting",
        "name": "Circular Saw — 7-1/4 in.",
        "runningWatts": 1400,
        "startingWatts": 2300,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-miter-saw",
        "category": "Cutting",
        "name": "Miter Saw — 10 in.",
        "runningWatts": 1500,
        "startingWatts": 3000,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-reciprocating-saw",
        "category": "Cutting",
        "name": "Reciprocating Saw",
        "runningWatts": 1200,
        "startingWatts": 2400,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-chain-saw",
        "category": "Cutting",
        "name": "Electric Chain Saw",
        "runningWatts": 1100,
        "startingWatts": 1100,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-angle-grinder",
        "category": "Grinding & Sanding",
        "name": "Angle Grinder — 4-1/2 in.",
        "runningWatts": 1200,
        "startingWatts": 2400,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-bench-grinder",
        "category": "Grinding & Sanding",
        "name": "Bench Grinder — 8 in.",
        "runningWatts": 1400,
        "startingWatts": 2500,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-hammer-drill",
        "category": "Drilling",
        "name": "Hammer Drill",
        "runningWatts": 1000,
        "startingWatts": 2000,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-rotary-hammer",
        "category": "Drilling",
        "name": "Rotary Hammer",
        "runningWatts": 1200,
        "startingWatts": 1200,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-demolition-hammer",
        "category": "Drilling",
        "name": "Demolition Hammer",
        "runningWatts": 1260,
        "startingWatts": 1260,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-belt-sander",
        "category": "Grinding & Sanding",
        "name": "Belt Sander",
        "runningWatts": 1000,
        "startingWatts": 2000,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-compressor-half-hp",
        "category": "Compressors & Cleaning",
        "name": "Air Compressor — 1/2 HP",
        "runningWatts": 975,
        "startingWatts": 1600,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": "jobsite-auto-restart-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true,
        "notes": "The compressor may restart automatically while another tool is operating."
      },
      {
        "scenario": "jobsite",
        "id": "job-shop-vac",
        "category": "Compressors & Cleaning",
        "name": "Shop Vacuum",
        "runningWatts": 1200,
        "startingWatts": 2400,
        "loadType": "motor",
        "voltage": 120,
        "popular": true,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": true,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-jobsite-heater",
        "category": "Lighting & Charging",
        "name": "Portable Jobsite Heater",
        "runningWatts": 1500,
        "startingWatts": 1500,
        "loadType": "steady",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": "jobsite-major-tools",
        "requiresNameplate": false,
        "autoRecommendationEligible": true
      },
      {
        "scenario": "jobsite",
        "id": "job-pressure-washer",
        "category": "High-Surge / Check First",
        "name": "Electric Pressure Washer — About 1 HP",
        "runningWatts": 1200,
        "startingWatts": 3600,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": false,
        "unsupportedReason": "Startup demand varies widely. Enter verified running and starting watts before a recommendation can be made."
      },
      {
        "scenario": "jobsite",
        "id": "job-compressor-one-hp",
        "category": "High-Surge / Check First",
        "name": "Air Compressor — 1 HP",
        "runningWatts": 1600,
        "startingWatts": 4500,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": true,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": false,
        "unsupportedReason": "Default startup demand leaves insufficient verified headroom in the current generator lineup."
      },
      {
        "scenario": "jobsite",
        "id": "job-table-saw",
        "category": "High-Surge / Check First",
        "name": "Table Saw — 10 in.",
        "runningWatts": 1800,
        "startingWatts": 4500,
        "loadType": "motor",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": false,
        "unsupportedReason": "Starting demand may exceed the current SIOKIUU lineup. Exact nameplate and measured startup data are required."
      },
      {
        "scenario": "jobsite",
        "id": "job-welder-120",
        "category": "High-Surge / Check First",
        "name": "Welder — 120V",
        "runningWatts": 2500,
        "startingWatts": 5000,
        "loadType": "electronic",
        "voltage": 120,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": false,
        "unsupportedReason": "Welder input demand varies by amperage and duty cycle. No automatic generator recommendation is available."
      },
      {
        "scenario": "jobsite",
        "id": "job-tool-240v",
        "category": "High-Surge / Check First",
        "name": "240V Jobsite Tool",
        "runningWatts": 0,
        "startingWatts": 0,
        "loadType": "motor",
        "voltage": 240,
        "popular": false,
        "userControlled": true,
        "autoRestart": false,
        "staggerGroup": null,
        "requiresNameplate": true,
        "autoRecommendationEligible": false,
        "unsupportedReason": "The current SIOKIUU generator lineup is listed for 120V output and is not recommended for this tool."
      }
    ]
  },
  "categories": {
    "home": [
      "Popular",
      "Refrigeration",
      "Lighting & Connectivity",
      "Medical & Electronics",
      "Heating & Cooling",
      "Kitchen",
      "Household",
      "High-Power / Unsupported"
    ],
    "rv": [
      "Popular",
      "Air Conditioning",
      "RV Essentials",
      "Kitchen",
      "Electronics",
      "Comfort & Personal Care"
    ],
    "jobsite": [
      "Popular",
      "Lighting & Charging",
      "Drilling",
      "Cutting",
      "Grinding & Sanding",
      "Compressors & Cleaning",
      "High-Surge / Check First"
    ]
  }
};
});
